import http from 'hub-http/clients/apiClient';
const API_BASE = 'global-home-api/eligible/v1';
export default class GlobalHomeAPI {
  static isEligible() {
    return http.get(`${API_BASE}/eligible`);
  }
}